"use client";

import { Button } from "@mui/material";
import Image from "next/image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@awesome.me/kit-c10ef98ed3/icons/classic/regular";
import { useTranslations } from "next-intl";
import { Variant } from "@/hooks/useVariant";
import { trackCtaClick } from "@/utils/commonEvents";
import { getAssetUrl } from "@/utils/assetUrl";

interface SleepClinicSectionProps {
  variant: Variant;
}

export default function SleepClinicSection({
  variant,
}: SleepClinicSectionProps) {
  const t = useTranslations("results-page.sleep-clinic-section");

  const imgSrc = getAssetUrl(
    variant === Variant.FEMALE
      ? "/images/results/sleep_clinic_female.webp"
      : "/images/results/sleep_clinic_default.webp",
  );

  return (
    <section className="sleep-clinic-section">
      <Image
        className={`sleep-clinic-section-image sleep-clinic-section-image--${variant}`}
        src={imgSrc}
        alt={t(`image-alt-${variant}`)}
        fill
        unoptimized
      />
      <div className="sleep-clinic-section-card">
        <h2
          className={`headline sleep-clinic-section-title sleep-clinic-section-title--${variant}`}
        >
          {t(`title-${variant}`)}
        </h2>
        <p className="sleep-clinic-section-body">{t(`body-${variant}`)}</p>
        <Button
          variant="contained"
          disableElevation
          disableRipple
          // TODO: OSAP-1721 Parameterize the link below per instance
          href="https://www.resmed.com/en-us/sleep-health/find-a-sleep-clinic/"
          target="_blank"
          rel="noopener noreferrer"
          className={`sleep-clinic-section-button sleep-clinic-section-button--${variant}`}
          onClick={() =>
            trackCtaClick({
              componentName: "sleep_assessment_pro",
              clickedArea: "Find a sleep clinic",
              clickedText: t(`button-${variant}`),
              clickedUrl:
                "https://www.resmed.com/en-us/sleep-health/find-a-sleep-clinic/",
            })
          }
        >
          {t(`button-${variant}`)}
          <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
        </Button>
      </div>
    </section>
  );
}
